import React from 'react';

function BottomNavbar() {
  return (
    <footer style={{ backgroundColor: '#ffffff', color: '#000', textAlign: 'center', padding: '10px 0', marginTop: '20px', fontFamily: 'Futura, sans-serif', fontSize: '10px' }}>
      &copy; 2026 Kenneth Nguyen. All Rights Reserved.
    </footer>
  );
}

export default BottomNavbar;
